<template>
  <div class="w100pct m2mm">
    <div class="w100pct txtC"><h1>低值易耗品购置验收单</h1></div>
    <div class="flexR m2mm">
      <p class="w50pct floatL">单号：{{ p_row.fcode }}</p>
      <p class="w50pct floatL">入库日期：{{ p_row.fdate }}</p>
      <p class="w50pct floatL">发票号:</p>
    </div>
    <div class="flexR m2mm">
      <p class="w50pct floatL">供货商:{{ p_row.fnamecust }}</p>
    </div>
    <table class="tbey">
      <tr>
        <td>物品名称</td>
        <td>型号规格</td>
        <td>单位</td>
        <td>数量</td>
        <td>单价</td>
        <td>金额</td>
        <td>品牌</td>
        <td>一致性</td>
        <td>外观</td>
        <td>性能</td>
        <td>备注</td>
      </tr>
      <tr v-for="(row,idx) in p_row.entrys" :key="idx">
        <td>{{ row.fnameitem }}</td>
        <td>{{ row.fmodel }}</td>
        <td>{{ row.fnameunit }}</td>
        <td>{{ row.fqty }}</td>

        <td>{{ row.fprice }}</td>
        <td>{{ row.famount }}</td>
        <td>{{ row.fnamebrand }}</td>
        <td/>

        <td/>
        <td/>
        <td>{{ row.fnotey }}</td>
      </tr><!--内容-->
      <tr>
        <td colspan="3">合计</td>
        <td/>
        <td colspan="4"/>
        <td colspan="4"/>
      </tr>
      <tr>
        <td colspan="2" rowspan="3">验收人</td>
        <td colspan="10"><p class="txtL">使用部门人员：</p></td>
      </tr>
      <tr>
        <td colspan="10"><p class="txtL">学校技术人员（或校外专家）：</p></td>
      </tr>
      <tr>
        <td colspan="10"><p class="txtL">资产管理处人员：</p></td>
      </tr>
      <tr>
        <td colspan="12">
          <p class="txtL">说明</p>
          <p class="txtL">1：单批次累计金额在5万元（含）以下的，需本部门两人以上验收签字即可，验收单一式两份，使用  部门、财务处各一份。</p>
          <p class="txtL">2：单批次累计金额在5万元以上的验收，验收单一式三份，使用部门、财务处、国资处各一份。</p>
        </td>
      </tr>
    </table>
    <p id="qrAsset" class="divQRCodexxxxxxxxxxxx"/>
  </div>
</template>
<script type="text/javascript">
import QRCode from 'qrcodejs2'
import html2canvas from 'html2canvas'
export default{
  name: 'Print01',
  props: {
    p_row: { type: Object, default: () => { return null } },
    toDo: {
      type: Function,
      default: null
    }
  },
  data: function() {
    return {
      bbShow: false
    }
  },
  activated: function() {
    this.prt('activated', this.p_code)
    // this.mkQrImg()
  },
  methods: {
    prt(a, b) {
      console.log(`11_assetPrt.${a}`, b)
    },
    mkQrImg() {
      const text = '100900.' + this.p_code
      $('#qrAsset').html('')
      new QRCode('qrAsset', {
        width: 220,
        height: 220,
        text: text
      })
      setTimeout(() => {
        this.saveImg(this.p_code + '-' + this.p_name)
      }, 1000)
    },
    saveImg(imgNm) {
      html2canvas(this.$refs.divAssetCode, {
        backgroundColor: null, // 画出来的图片有白色的边框,不要可设置背景为透明色（null）
        useCORS: true, // 支持图片跨域
        scale: 1 // 设置放大的倍数
      }).then((canvas) => {
        const url = canvas.toDataURL('image/png') // toDataURL: 图片格式转成 base64
        this.imgUrl = url
        const a = document.createElement('a') // 生成一个a元素
        const event = new MouseEvent('click') // 创建一个单击事件
        a.download = imgNm // 设置图片名称没有设置则为默认
        a.href = this.imgUrl // 将生成的URL设置为a.href属性
        a.dispatchEvent(event) // 触发a的单击事件
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/comps/c4_prt/p01_in.vue